import { log } from 'util';
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { NewTestTimeComponent } from '../new-test-time/new-test-time.component';
import { QuestionDifficultyComponent } from '../question-difficulty/question-difficulty.component';
import { NewTopicComponent } from '../new-topic/new-topic.component';
import { TestFormatComponent } from '../test-format/test-format.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';
import { Router } from '@angular/router';
import { EditTopicComponent } from '../edit-topic/edit-topic.component';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  flag: boolean = false;
  i: number;
  testDifficulty2: any;
  digitExp = '^[0-9]*$';
  val;
  checkError: boolean = true;
  flagEdit: boolean = false;



  indexForEditTestFormat;
  selectedTestType;
  topicType = new FormControl('', [Validators.required]);
  alphabetExp = '[a-zA-Z ]*$';
  minutes = new FormControl(null, [Validators.required, Validators.pattern(this.digitExp)]);
  testname = new FormControl(null, [Validators.required, this.noWhitespaceValidator, Validators.pattern(this.alphabetExp)]);
  testNameForTestFormat = new FormControl(null, [Validators.required, this.noWhitespaceValidator]);
  difficultyName = new FormControl('', [Validators.required]);
  marks = new FormControl('', [Validators.required, Validators.pattern('^[0-9]*')]);
  time = new FormControl('', [Validators.required, Validators.pattern('^[0-9]*')]);
  testDifficulty;
  testType = new FormControl('');
  testTimeName = new FormControl('');
  topicDifficulty = new FormControl('');
  topicDifficultyArray = [];
  questionDifficultyVar = new FormControl('', [Validators.required]);
  noOfProgramQues = new FormControl('', [Validators.required, Validators.pattern('^[0-9]*')]);
  easy = new FormControl('', Validators.required);
  medium = new FormControl('', Validators.required);
  hard = new FormControl('', Validators.required);
  veryhard = new FormControl('', Validators.required);
  testformatEditable = false;
  testTimeList = [];
  activeTestTimeList = [];
  questionDifficultyList = [];
  activeQuestionDifficultyList = [];
  topicList = [];
  testFormatList = [];
  activeTestFormatList = [];
  easyTopicList = [];
  mediumTopicList = [];
  hardTopicList = [];
  easyTopic = new FormControl('');
  mediumTopic = new FormControl('');
  hardTopic = new FormControl('');
  topicNameList = [];
  topicTypeArr = ['Easy', 'Medium', 'Hard'];
  easyPercentage; mediumPercentage; hardPercentage; veryhardPercentage; percentageOfNo;
  testSelect='';
  testTypeSelected: any;
  activeTopicNameList = [];
  testDifficulty1: any;
  timeDurationId: any;
  testTime: any;
  testName: any;
  oldTestTimeName: any;
  testValue: any;
  constructor(private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private httpService: HttpService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getTestTime();
    this.getQuestionDifficulty();
    this.getTopicList();
    this.getTestFormatList();
    this.getTopicNameList();
  }

  getErrorForMinutes() {
    return this.minutes.hasError('required') ? 'This field is required' :
      this.minutes.hasError('pattern') ? 'Enter valid test time' :
        '';
  }

  getErrorForTestName1() {
    return this.testNameForTestFormat.hasError('required') ? 'This field is required' :
      this.testNameForTestFormat.hasError('whitespace') ? 'Enter valid test name' :

        '';
  }

  getErrorForTestName() {
    return this.testname.hasError('required') ? 'This field is required' :
      this.testname.hasError('pattern') ? 'Enter valid test name' :
        this.testname.hasError('whitespace') ? 'Enter valid test name' :
          '';
  }


  makeEditable1(item) {
    this.flag = false;
    this.i = 0;
    console.log("item", item);
    
  
    
    for (let i = 0; i < this.activeTestTimeList.length; i++) {

      if (item.testTimeId === this.activeTestTimeList[i].id) {
        this.oldTestTimeName = this.activeTestTimeList[i].id;
      }
    }
    this.testDifficulty1 = item.testDifficulty;
  }

  makeEditable(value, testTimeId, index) {
    console.log('test time Id--->', testTimeId);

    var tempTestTime;
    for (let i = 0; i < this.activeTestTimeList.length; i++) {
      console.log(this.activeTestTimeList[i]);

      if (testTimeId === this.activeTestTimeList[i].id) {
        tempTestTime = this.activeTestTimeList[i];
        this.testSelect = this.activeTestTimeList[i].testName;
        // console.log('selected test-->', this.testSelect);
      }
    }


    if (value == 'time') {
      if (this.activeTestTimeList[index].isEditable === false || this.activeTestTimeList[index].isEditable === undefined) {
        for (let i = 0; i < this.activeTestTimeList.length; i++) {
          this.activeTestTimeList[i].isEditable = false
        }
        this.activeTestTimeList[index].isEditable = true;
      }
      else {
        this.activeTestTimeList[index].isEditable = false;
      }
    }

    else if (value == 'difficulty') {


      if (this.activeQuestionDifficultyList[index].isEditable === false
        || this.activeQuestionDifficultyList[index].isEditable === undefined) {
        for (let i = 0; i < this.activeQuestionDifficultyList.length; i++) {
          this.activeQuestionDifficultyList[i].isEditable = false
        }
        this.activeQuestionDifficultyList[index].isEditable = true;
      }
      else {
        this.activeQuestionDifficultyList[index].isEditable = false;
      }
    }
    else if (value == 'testformat') {
      // console.log("value", value);
      console.log("time", tempTestTime)
      if (this.activeTestFormatList[index].isEditable === false || this.activeTestFormatList[index].isEditable === undefined) {
        for (let i = 0; i < this.activeTestFormatList.length; i++) {
          this.activeTestFormatList[i].isEditable = false
        }

        this.activeTestFormatList[index].isEditable = true;
        //console.log('editable--->',(this.activeTestTimeList[index]));

        this.indexForEditTestFormat = this.activeTestFormatList[index];
        this.easyPercentage = Math.floor((tempTestTime.testTime * 60 / 100) *
          this.activeTestFormatList[index].complexityOneCount / this.getElementByDifficultyName('Easy').time);
        this.mediumPercentage = Math.floor((tempTestTime.testTime * 60 / 100) *
          this.activeTestFormatList[index].complexityTwoCount / this.getElementByDifficultyName('Medium').time);
        this.hardPercentage = Math.floor((tempTestTime.testTime * 60 / 100) *
          this.activeTestFormatList[index].complexityThreeCount / this.getElementByDifficultyName('Hard').time);
        this.veryhardPercentage = Math.floor((tempTestTime.testTime * 60 / 100) *
          this.activeTestFormatList[index].complexityFourCount / this.getElementByDifficultyName('Very Hard').time);
        var numberOfQuestion = this.easyPercentage + this.mediumPercentage + this.hardPercentage + this.veryhardPercentage;
        this.percentageOfNo = Math.ceil((numberOfQuestion * this.activeTestFormatList[index].noOfProgrammingQuestion) / 100);
        // this.autoFillQuestionDifficulty(this.activeTestFormatList[index].testDifficulty)

        console.log("this.percentageOfNo", this.easyPercentage);
        console.log(this.mediumPercentage);
        console.log(this.hardPercentage);
        console.log(this.veryhardPercentage);
      }
      else {
        this.activeTestFormatList[index].isEditable = false;
      }
    }
  }

  newTestTime() {
    const dialogRef = this.dialog.open(NewTestTimeComponent, {
      disableClose: true,
      minWidth: '400px',
      panelClass: "dialog-style"

    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result === true) {
        this.getTestTime();
      }
    });
  }

  questionDifficulty() {
    const dialogRef = this.dialog.open(QuestionDifficultyComponent, {
      disableClose: true,
      minWidth: '400px',
      panelClass: "dialog-style"
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result === true) {
        this.getQuestionDifficulty();
      }
    });
  }

  newTopic() {
    const dialogRef = this.dialog.open(NewTopicComponent, {
      disableClose: true,
      minWidth: '400px',
      panelClass: "dialog-style",
      data: this.topicNameList
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result) {
        this.getTopicList();
      }
    });
  }

  editTopic(topic) {
    console.log("editTopic", topic);
    const dialogRef = this.dialog.open(EditTopicComponent, {
      disableClose: true,
      minWidth: '400px',
      panelClass: "dialog-style",
      data: topic
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result == true) {
        this.editTopicList(topic);
      }
    });
  }
  testFormat() {
    const dialogRef = this.dialog.open(TestFormatComponent, {
      disableClose: true,
      // minWidth: '400px'
      panelClass: "dialog-style",
      data: {
        "questionDifficulty": this.activeQuestionDifficultyList,
        "testTime": this.activeTestTimeList,
        "easyTopicList": this.easyTopicList,
        "mediumTopicList": this.mediumTopicList,
        "hardTopicList": this.hardTopicList
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      // this.timeDurationId = result;

      // for(let i=0; i < this.activeTestTimeList.length; i++) {
      //   console.log("this.activeTestTimeList[i].testName;",this.activeTestTimeList[i].testName);
      //   console.log("this.timeDurationId",this.timeDurationId);
      //   console.log("this.activeTestTimeList[i].id",this.activeTestTimeList[i].id);
      //   if(this.timeDurationId === this.activeTestTimeList[i].id)
      //    this.testName = this.activeTestTimeList[i].testName;
      // }

      if (result === true) {
        this.getTestFormatList();
      }
    });
  }

  getTopicNameList() {
    this.activeTopicNameList = [];
    this.spinnerService.show();
    // tslint:disable-next-line:prefer-const
    let contentBody = { url: '/distincttopics' };
    this.httpService.httpGet(contentBody).subscribe(response => {
      this.topicNameList = response.data;
      // console.log("topicNameList", this.topicNameList);

      // for (let i = 0; i < this.topicNameList.length; i++) {
      //   if (this.topicNameList[i].status === 'active') {
      //     this.activeTopicNameList.push(this.topicNameList[i]);
      //   }
      // }
      // console.log("activeTopicNameList", this.activeTopicNameList);
      this.spinnerService.hide();

    }, error => {
      console.log('error ', error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    });

  }
  getTestTime() {
    this.activeTestTimeList = [];
    this.spinnerService.show();
    // tslint:disable-next-line:prefer-const
    let contentBody = { url: '/testtimes' };
    this.httpService.httpGet(contentBody).subscribe(response => {
      console.log("getTestTime", response);
      this.testTimeList = response.data;
      for (let i = 0; i < this.testTimeList.length; i++) {
        if (this.testTimeList[i].status === 'ACTIVE') {
          this.activeTestTimeList.push(this.testTimeList[i]);
        }
      }
      // for(let i=0; i < this.activeTestTimeList.length; i++) {
      //   console.log("this.activeTestTimeList[i].testName;",this.activeTestTimeList[i].testName);
      //   console.log("this.timeDurationId",this.timeDurationId);
      //   console.log("this.activeTestTimeList[i].id",this.activeTestTimeList[i].id);
      //   if(this.timeDurationId === this.activeTestTimeList[i].id)
      //    this.testName = this.activeTestTimeList[i].testName;
      // }
      console.log("activeTestTimeList", this.activeTestTimeList);
      console.log("this.activeTestTimeList.length", this.activeTestTimeList.length);
      console.log("this.testName", this.testName);
      this.spinnerService.hide();

    }, error => {
      console.log('error ', error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    });
  }

  getQuestionDifficulty() {
    this.activeQuestionDifficultyList = [];
    this.spinnerService.show();
    // tslint:disable-next-line:prefer-const
    let contentBody = { url: '/questiondifficulties' };
    this.httpService.httpGet(contentBody).subscribe(response => {
      console.log("getQuestionDifficulty", response);
      this.questionDifficultyList = response.data;
      this.activeQuestionDifficultyList = [];
      for (let i = 0; i < this.questionDifficultyList.length; i++) {
        if (this.questionDifficultyList[i].status === 'ACTIVE') {
          this.activeQuestionDifficultyList.push(this.questionDifficultyList[i]);
        }
      }
      // console.log("activeQuestionDifficultyList", this.activeQuestionDifficultyList);

      this.spinnerService.hide();

    }, error => {
      console.log('error ', error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    });
  }

  getTopicList() {
    this.spinnerService.show();
    // tslint:disable-next-line:prefer-const
    let contentBody = { url: '/topics' };
    this.httpService.httpGet(contentBody).subscribe(response => {
      console.log('respose', response);
      this.topicList = response.data;
      console.log(this.topicList);

      this.easyTopicList = [];
      this.mediumTopicList = [];
      this.hardTopicList = [];
      for (let i = 0; i < this.topicList.length; i++) {
        if (this.topicList[i].topicComplexity == 1) {
          if (this.topicList[i].status == 'ACTIVE')
            this.easyTopicList.push(this.topicList[i]);
        }
        else if (this.topicList[i].topicComplexity == 2) {
          if (this.topicList[i].status == 'ACTIVE')
            this.mediumTopicList.push(this.topicList[i]);
        }
        else {
          if (this.topicList[i].status == 'ACTIVE')
            this.hardTopicList.push(this.topicList[i]);
        }
      }
      this.spinnerService.hide();
      console.log("this.hardTopicList", this.hardTopicList);


    }, error => {
      console.log('error ', error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message)
    })
  }
  getTestFormatList() {
    this.activeTestFormatList = []
    this.spinnerService.show();
    var contentBody = { url: '/questionsetformats' }
    this.httpService.httpGet(contentBody).subscribe(response => {
      console.log('respose questionsetformats', response);
      this.testFormatList = response.data;
      for (let i = 0; i < this.testFormatList.length; i++) {
        if (this.testFormatList[i].status === 'ACTIVE') {
          this.activeTestFormatList.push(this.testFormatList[i]);
        }
      }
      console.log("activeTestFormatList", this.activeTestFormatList);
      this.spinnerService.hide();

    }, error => {
      console.log('error ', error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message)
    })
  }
  editTestTime(index) {

    var currentEdit = this.activeTestTimeList[index];
    console.log("currentEdit", currentEdit);

    var data = {
      // testName: currentEdit.testName,
      // testTime: currentEdit.testTime
      testTime: this.minutes.value,
      testName: this.testname.value
    };


    var data1 = {
      testTime: this.minutes.value,
      testName: this.testname.value,

    }
    console.log("mydaata", this.testname.value, "time", this.minutes.value)


    console.log("times", data)
    if (currentEdit.testTime > 0) {
      this.spinnerService.show();
      var contentBody = { url: '/testtimes/' + currentEdit.id, body: data1 };
      this.httpService.httpPost(contentBody, true).subscribe(response => {
        console.log('success ', response);
        this.openSnackBar(response['message']);
        this.spinnerService.hide();
        this.getTestTime();
        this.getTestFormatList();

      }, error => {
        console.log('error ', error);
        this.spinnerService.hide();
        this.openSnackBar(error.error.message);
      });
    } else {
      this.openSnackBar("Please provide valid test time")
    }

  }

  editTopicList(data) {
    console.log("data", data);
    var updateData = {
      topicComplexity: data.topicComplexity,
      topicName: data.topicName
    }
    console.log("Test time Data", data);
    this.spinnerService.show();
    var contentBody = { url: "/topics/" + data.id, body: updateData }
    this.httpService.httpPost(contentBody, true).subscribe(response => {
      console.log("success ", response);
      this.openSnackBar(response["message"]);
      this.spinnerService.hide();
      this.getTopicList();
    }, error => {
      console.log("error ", error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    })
  }
  editQuestionDifficulty(index) {
    var currentEdit = this.activeQuestionDifficultyList[index];
    console.log(currentEdit);
    var data = {
      difficultyName: currentEdit.difficultyName,
      marks: this.marks.value,
      time: this.time.value
    };
    if (data.marks > 0 && data.time > 0) {
      this.spinnerService.show();
      var contentBody = { url: '/questiondifficulties/' + currentEdit.id, body: data };
      this.httpService.httpPost(contentBody, true).subscribe(response => {
        console.log('success ', response);
        this.openSnackBar(response['message']);
        this.spinnerService.hide();
        this.getQuestionDifficulty();
        this.getTestFormatList();
      }, error => {
        console.log('error ', error);
        this.spinnerService.hide();
        this.openSnackBar(error.error.message);
      });
    }
    else {
      this.openSnackBar("Provide valid data")
    }
  }
  onCheckboxChagen(event, value) {
    if (event.checked) {
      if (value == 'Easy') {
        value = 1;
      }
      if (value == 'Medium') {
        value = 2;
      }
      if (value == 'Hard') {
        value = 3;
      }
      if (this.topicDifficultyArray.indexOf(value) == -1) {
        this.topicDifficultyArray.push(value);
      }
    }
    if (!event.checked) {
      let index = this.topicDifficultyArray.indexOf(value);
      if (index > -1) {
        this.topicDifficultyArray.splice(index, 1);
      }
    }
    console.log("topicDifficultyArray", this.topicDifficultyArray);
    return this.topicDifficultyArray;
  }
  onCheckboxChagen1(event, value, index) {
    if (value == 'Easy') {
      value = 1;
    }
    if (value == 'Medium') {
      value = 2;
    }
    if (value == 'Hard') {
      value = 3;
    }
    if (event.checked) {
      if (this.activeTestFormatList[index].topicDifficulty.indexOf(value) == -1) {
        this.activeTestFormatList[index].topicDifficulty.push(value);
      }
    }
    if (!event.checked) {
      let index1 = this.activeTestFormatList[index].topicDifficulty.indexOf(value);
      console.log(index1)
      if (index1 > -1) {
        this.activeTestFormatList[index].topicDifficulty.splice(index1, 1);
      }
    }
    console.log("topicDifficultyArray", this.activeTestFormatList[index].topicDifficulty);
    // return this.topicDifficultyArray;
  }

  openSnackBar(message: string) {
    if (message) {
      this.snackbar.open(message, null, {
        duration: 2000,
      });
    }
    else {
      this.snackbar.open('Network Error', null, {
        duration: 2000,
      });
    }
  }

  getElementByDifficultyName(name) {
    return this.activeQuestionDifficultyList.find(x => x.difficultyName == name)
  }
  autoFillQuestionDifficulty(value) {
    console.log("test Difficulty", this.testDifficulty1);
    console.log("value", value);
    if (value === undefined) {
      value = this.testDifficulty1;
    }
    if (this.i == 0 && this.flag === false) {
      console.log("i", this.testDifficulty1, " ", this.i);
      value = this.testDifficulty1;
      this.i++;
    }
    console.log("change", value);

    if (value != undefined) {
      if (value == 'Easy') {
        let value1 = parseInt(this.medium.value) + parseInt(this.hard.value) + parseInt(this.veryhard.value);
        if (!isNaN(value1)) {
          this.val = 100 - value1;
          this.easy.setValue(this.val);
          // if (this.easy.value < 0 || this.easy.value > 100) {
          //   this.easy.setValue(0);
          // }
          if (this.easy.value < 0) {
            this.easy.setValue(100);
          }
          if (this.easy.value > 100) {
            this.easy.setValue(0);
          }
          if (this.medium.value < 0 || this.medium.value > 100) {
            this.medium.setValue(0);
          }
          if (this.hard.value < 0 || this.hard.value > 100) {
            this.hard.setValue(0);
          }
          if (this.veryhard.value < 0 || this.veryhard.value > 100) {
            this.veryhard.setValue(0);
          }
          // console.log("Medium value",this.medium.value);

        }
      }
      else if (value == 'Medium') {
        let value1 = parseInt(this.easy.value) + parseInt(this.hard.value) + parseInt(this.veryhard.value);
        if (!isNaN(value1)) {
          this.val = 100 - value1;
          this.medium.setValue(this.val);
          // if (this.medium.value < 0 || this.medium.value > 100) {
          //   this.medium.setValue(0);
          // }
          if (this.medium.value < 0) {
            this.medium.setValue(100);
          }
          if (this.medium.value > 100) {
            this.medium.setValue(0);
          }
          if (this.easy.value < 0 || this.easy.value > 100) {
            this.easy.setValue(0);
          }
          if (this.hard.value < 0 || this.hard.value > 100) {
            this.hard.setValue(0);
          }
          if (this.veryhard.value < 0 || this.veryhard.value > 100) {
            this.veryhard.setValue(0);
          }
        }
      }
      else if (value == 'Hard') {
        let value1 = parseInt(this.easy.value) + parseInt(this.medium.value) + parseInt(this.veryhard.value);
        if (!isNaN(value1)) {
          this.val = 100 - value1;
          this.hard.setValue(this.val);
          // if (this.hard.value < 0 || this.hard.value > 100) {
          //   this.hard.setValue(0);
          // }
          if (this.hard.value < 0) {
            this.easy.setValue(100);
          }
          if (this.hard.value > 100) {
            this.easy.setValue(0);
          }
          if (this.medium.value < 0 || this.medium.value > 100) {
            this.medium.setValue(0);
          }
          if (this.easy.value < 0 || this.easy.value > 100) {
            this.hard.setValue(0);
          }
          if (this.veryhard.value < 0 || this.veryhard.value > 100) {
            this.veryhard.setValue(0);
          }
        }
      }
      else {
        let value1 = parseInt(this.medium.value) + parseInt(this.hard.value) + parseInt(this.easy.value);
        if (!isNaN(value1)) {
          this.val = 100 - value1;
          this.veryhard.setValue(this.val);
          // if (this.veryhard.value < 0 || this.veryhard.value > 100) {
          //   this.veryhard.setValue(0);
          // }
          if (this.veryhard.value < 0) {
            this.easy.setValue(100);
          }
          if (this.veryhard.value > 100) {
            this.easy.setValue(0);
          }
          if (this.medium.value < 0 || this.medium.value > 100) {
            this.medium.setValue(0);
          }
          if (this.hard.value < 0 || this.hard.value > 100) {
            this.hard.setValue(0);
          }
          if (this.easy.value < 0 || this.easy.value > 100) {
            this.easy.setValue(0);
          }
        }
      }
    }
    console.log("this.activeTestTimeList", this.activeTestTimeList);

    if (this.easy.value != null && this.easy.value != undefined) {
      this.easyPercentage = Math.floor((this.testValue * 60 / 100) * parseInt(this.easy.value) /
        this.getElementByDifficultyName('Easy').time);
    }
    else {
      this.easyPercentage = 0;
    }
    if (this.medium.value != null && this.medium.value != undefined) {
      this.mediumPercentage = Math.floor((this.testValue * 60 / 100) * parseInt(this.medium.value) /
        this.getElementByDifficultyName('Medium').time);
    }
    else {
      this.mediumPercentage = 0;
    }
    if (this.hard.value != null && this.hard.value != undefined) {
      this.hardPercentage = Math.floor((this.testValue * 60 / 100) * parseInt(this.hard.value) /
        this.getElementByDifficultyName('Hard').time);
    } else {
      this.hardPercentage = 0;
    }
    if (this.veryhard.value != null && this.veryhard.value != undefined) {
      this.veryhardPercentage = Math.floor((this.testValue * 60 / 100) * parseInt(this.veryhard.value) /
        this.getElementByDifficultyName('Very Hard').time);
    }
    else {
      this.veryhardPercentage = 0;
    }
    var numberOfQuestion = this.easyPercentage + this.mediumPercentage + this.hardPercentage + this.veryhardPercentage;
    this.percentageOfNo = Math.ceil((numberOfQuestion * this.indexForEditTestFormat.noOfProgrammingQuestion) / 100);

    this.percentageOfNo = Math.ceil((numberOfQuestion * this.noOfProgramQues.value) / 100);
  }
  onChangeTestType(event) {
    this.easy.setValue(0);
    this.medium.setValue(0);
    this.hard.setValue(0);
    this.veryhard.setValue(0);
    this.testTypeSelected = event.value;
    console.log("this.testTypeSelected", this.testTypeSelected);
    this.flag = true;
    //this.i++;
    //localStorage.setItem('tts',this.testTypeSelected);
    this.autoFillQuestionDifficulty(this.testTypeSelected);
  }

  editTestFormat(index) {
    console.log('index:', index);
    console.log("result:", index.name)
    console.log('testTimeName:', this.testTimeName.value.id);
    console.log('oldTestTimeName', this.oldTestTimeName);
  //  console.log('type', typeof this.oldTestTimeName);
    
     if(this.testTimeName.value.id !== undefined) {
    //   this.testTimeName.value.id = this.oldTestTimeName;
    this.oldTestTimeName = this.testTimeName.value.id;
     }
    console.log('testTimeName:', this.testTimeName.value.id);
    const currentEdit = this.activeTestFormatList[index];
    console.log("currentEdit", currentEdit);

    console.log("this.activeTestFormatList", this.activeTestFormatList);

    //  if(this.hardTopicList.length > 0 && localStorage.getItem('tts') == 'Hard' || this.mediumTopicList.length > 0 && localStorage.getItem('tts') == 'Medium' || this.easyTopicList.length > 0 && localStorage.getItem('tts') == 'Easy') {


    var data = {
      name: this.testNameForTestFormat.value,
      noOfProgrammingQuestion: this.noOfProgramQues.value,
      testDifficulty: currentEdit.testDifficulty,
      topicDifficulty: currentEdit.topicDifficulty,
      complexityFourCount: this.veryhard.value,
      complexityOneCount: this.easy.value,
      complexityThreeCount: this.hard.value,
      complexityTwoCount: this.medium.value,
      // testTimeId: currentEdit.testTimeId
      //testTimeId: this.testTimeName.value.id
      testTimeId: this.oldTestTimeName
    };

    console.log("Data:", data);

    let isValid = this.checkEditTestFormatData(currentEdit);
    console.log("isValid", isValid);

    if (isValid) {
      this.spinnerService.show();
      var contentBody = { url: "/questionsetformats/" + currentEdit.id, body: data }
      this.httpService.httpPost(contentBody, true).subscribe(response => {
        console.log('success ', response);
        this.openSnackBar(response['message']);
        this.spinnerService.hide();
        this.getTestFormatList();
      }, error => {
        console.log('error ', error);
        this.spinnerService.hide();
        this.openSnackBar(error.error.message);
      })
    }
    else {
      this.activeTestFormatList[index].isEditable = true
      this.openSnackBar("Provide valid data")
    }


    // }
    // else {
    //   this.openSnackBar("abcdefg");
    // }

  }
  checkEditTestFormatData(currentEdit) {
    console.log("Called", currentEdit);
    let total = +this.easy.value + +this.medium.value + +this.hard.value + +this.veryhard.value;
    if (total == 100) {
      if (this.easy.value >= 0 &&
        this.medium.value >= 0 &&
        this.hard.value >= 0 &&
        this.veryhard.value >= 0) {
        if (currentEdit.testDifficulty === 'Easy') {
          if (this.easy.value >= this.activeTestTimeList[0].minPercentage) {
            return true;
          } else
            return false;
        }
        if (currentEdit.testDifficulty === 'Medium') {
          console.log("dsfjshdfjsd");

          if (this.medium.value >= this.activeTestTimeList[0].minPercentage) {
            return true;
          } else
            return false;
        }
        if (currentEdit.testDifficulty === 'Hard') {
          if (this.hard.value >= this.activeTestTimeList[0].minPercentage) {
            return true;
          } else
            return false;
        }
      }
      else {
        return false;
      }
    } else
      return false;

  }

  cancle() {

    this.testDifficulty2 = this.testDifficulty1;
    console.log("cancle", this.testDifficulty2);

  }


  questionDifficulty1(time) {
    console.log("time", time);

  }


  public noWhitespaceValidator(control: FormControl) {
    // console.log('value', control.value);

    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  selectTime(time, index) {
    console.log('index:', index);
    console.log('testTimeName', this.testTimeName);
    console.log('testTimeNameValueId', this.testTimeName.value.id);
    console.log('time', time.value);
    this.testValue = time.value.testTime;
    this.autoFillQuestionDifficulty(this.testTypeSelected);
  }

}
